module.exports = __webpack_public_path__ + "img/mastercard.7e97c9cf.png";